/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: process.env.VUE_APP_NAME ?? 'BenefactorX',
    appTitle: process.env.VUE_APP_TITLE ?? 'Gestione benefattori e donazioni',
    appDir: process.env.VUE_APP_CUSTOM_DIR,
    appLogoImageUrl: require(`@/assets/images/logo/${process.env.VUE_APP_CUSTOM_DIR}/logo.png`),
    appVersion: process.env.VUE_APP_VERSION,
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: true,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'hidden', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: false,
  },
}
